<template>
    <div class="navbar navbar-default navbar-fixed-bottom footer">
        <ul class="nav navbar-nav visible-xs-block">
            <li><a class="text-center collapsed" data-toggle="collapse" data-target="#footer"><i class="icon-circle-up2"></i></a></li>
        </ul>

        <div class="navbar-collapse collapse" id="footer">
            <div class="navbar-text">
                &copy; 2018. Copyrights by <router-link to="/about"><img width="80" src="/assets/img/signature.png" style="padding-left: 5px"/></router-link>
            </div>

            <div class="navbar-right">
                <ul class="nav navbar-nav" style="padding-top: 5px">
                    <li><router-link to="/about">About</router-link></li>
                    <li><a href="mailto:andrei.hirvi@gmail.com">Contact</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default { }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Footer.vue?62afcdc3